/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: SimpleTextShapeControl.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1649
 * ---
 * Description:
 */

import {ControlTypes} from '../../selection-properties';
import {ShapeControl, ShapeControlInitParams} from './ControlGroup';
import {ControlFieldChildComponentRenderer} from "../../../components/editor/controls/TextBasedControlInput";

export class SimpleTextShapeControl extends ShapeControl<string> {
    public placeholder?: string;
    public rightElementRenderer?: ControlFieldChildComponentRenderer;

    constructor(initParams: ShapeControlInitParams<string>, {
        placeholder,
        rightElementRenderer
    }: { placeholder: string, rightElementRenderer?: ControlFieldChildComponentRenderer }) {
        super(initParams);
        this.placeholder = placeholder;
        this.controlType = ControlTypes.SIMPLE_TEXT
        this.rightElementRenderer = rightElementRenderer;
    }
}